module.exports = __webpack_public_path__ + "img/1.83da1156.jpg";